/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest
 */
export interface DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest
     */
    order_id?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequestFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest {
    return DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequestFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'order_id': !exists(json, 'order_id') ? undefined : json['order_id'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequestToJSON(value?: DigitizingserviceMelcoDigitizingModelsCopyOrderToAppRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order_id': value.order_id,
    };
}


